import React, { useEffect, useState ,Fragment} from "react";
import Cookies from "js-cookie";
// import VideoSection from "../components/partials/RejuvenationDetail/VideoSection";
import SkincareSliderSection from "../components/partials/SkincareDetail/SkincareSliderSection";

const Skincare = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    window.scrollTo(0, 0);
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => {
        if (prev !== currentLang) return currentLang;
        return prev;
      });
    }, 1000); // check every second

    return () => clearInterval(interval);
  }, []);

  const images = [
    "/assets/images/Skincare/Skincare-1.jpg",
    "/assets/images/Skincare/Skincare-2.jpg",
    "/assets/images/Skincare/Skincare-3.jpg",
    "/assets/images/Skincare/Skincare-4.jpg",
    "/assets/images/Skincare/Skincare-5.jpg",
    "/assets/images/Skincare/Skincare-6.jpg",
  ];

  const SkincareSliderSectionTranslations = {
    en: {
      title: "Skincare Products",
      description:
        "Get gorgeous, healthy, young looking and glowing skin, wherever life takes you, with day to day skincare powered by nature and proven by science.",
      button: "Order Now!",
    },
    ar: {
      title: "منتجات العناية بالبشرة",
      description:
        "احصلي على بشرة جميلة وصحية وشابة ومتوهجة، أينما تأخذكِ الحياة، من خلال روتين يومي للعناية بالبشرة مدعوم بالطبيعة ومثبت علميًا.",
      button: "اطلب الآن!",
    },
  };

  return (
    <Fragment>
      <div className="container">
        <SkincareSliderSection
          translations={SkincareSliderSectionTranslations}
          images={images}
          lang={language}
          link={"/order"}
        />
      </div>
      {/* <div className="container">
        <ProductGrid lang={language} kits={kits} translations={translations} link={"/skincare-order-page"} />
      </div>

      <GalvanicBodyKit lang={language} /> */}
     
    </Fragment>
  );
};

export default Skincare;
